module.exports = __webpack_public_path__ + "static/media/our-accelerator.19978b95.svg";